module.exports = __webpack_public_path__ + "img/basic.f7c901bb.png";